<template>
  <div :class="classObj" class="app-wrapper">
    <sidebar id="sidebar-container" :class="{'disabled-click':canClick}" class="sidebar-container" />
    <div :class="{hasTagsView:needTagsView}" class="main-container" @click="MBtoggles">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar />
        <tags-view v-if="needTagsView" @refresh-view="refreshView" />
      </div>
      <app-main ref="appMain" />
      <!-- <right-panel>
        <settings />
      </right-panel> -->
    </div>
  </div>
</template>

<script>
import rightPanel from "@/components/common/rightPanel";
import { appMain, sidebar, tagsView, navbar, settings } from "./common";
import steps from "@/components/common/guide/steps";
export default {
  components: {
    rightPanel,
    appMain,
    sidebar,
    tagsView,
    navbar,
    settings,
  },
  computed: {
    needTagsView() {
      return this.$store.state.settings.tagsView;
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    classObj() {
      var sidebar = this.$store.state.app.sidebar;
      return {
        hideSidebar: !sidebar.opened,
        openSidebar: sidebar.opened,
        withoutAnimation: sidebar.withoutAnimation,
      };
    },
    canClick() {
      return this.$store.state.user.changePwd;
    },
  },
  mounted() {
    let user = this.$store.state.user;
    // console.log("store.user", user);
    if (user.changePwd == true) {
      this.$driver.defineSteps(steps);
      this.$driver.start();
    }
    // window.addEventListener("beforeunload", (e) => this.onBeforeUnload(e));
    // window.addEventListener("unload", (e) => this.onUnload(e));
  },
  // destroyed() {
  //   window.removeEventListener("beforeunload", (e) => this.onBeforeUnload(e));
  //   window.removeEventListener("unload", (e) => this.onUnload(e));
  // },
  methods: {
    // onBeforeUnload() {
    //   this._beforeUnload_time = new Date().getTime();
    // },
    // onUnload(e) {
    //   this._gap_time = new Date().getTime() - this._beforeUnload_time;
    //   debugger;
    //   //判断是窗口关闭还是刷新
    //   if (this._gap_time <= 5) {
    //     console.log("关闭");
    //     //如果是登录状态，关闭窗口前，移除用户
    //     this.$store.dispatch("logout");
    //     document.cookie = "关闭浏览器";
    //   } else {
    //     console.log("刷新");
    //   }
    // },
    refreshView(name) {
      this.$refs.appMain.refreshView(name);
    },
    MBtoggles() {
      if (this.$store.state.isMB) {
        this.$store.dispatch("MBtoggleSideBar");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.content {
  padding: 10px;
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
  @media screen and (max-width: 767px) {
    width: 100%;
  }
}

.mobile .fixed-header {
  width: 100%;
}
</style>
